import { customAxios } from "@/shared/config/axios-interceptor";

const PATH_MASTER = '/routes';

export default class UserService {
  public async getMasterList(): Promise<any> {
    try {
      const res = await customAxios.get(`${PATH_MASTER}/filter/masters`);
      return res;
    } catch (error) {
      return Promise.reject(error.response ? error.response : error);
    }
  };

  public async getData(masterId): Promise<any> {
    try {
      const res = await customAxios.get(`${PATH_MASTER}/filter/${masterId}`);
      return res;
    } catch (error) {
      return Promise.reject(error.response ? error.response : error);
    }
  };

  public async getBusTopList(param): Promise<any> {
    try {
      const res = await customAxios.get(`${PATH_MASTER}/stops?master_id=${param.masterId}&office_id=${param.officeId}&pattern_id=${param.specificRouteId}&route_id=${param.mainRouteId}&stop_id=`);
      return res;
    } catch (error) {
      return Promise.reject(error.response ? error.response : error);
    }
  };

  public async getDataByBusStopId(param): Promise<any> {
    try {
      const res = await customAxios.post(`${PATH_MASTER}/filter?master_id=${param.masterId}&stop_id=${param.busStopId}`);
      return res;
    } catch (error) {
      return Promise.reject(error.response ? error.response : error);
    }
  };

  public async updateStop(param): Promise<any> {
    try {
      const res = await customAxios.put(`${PATH_MASTER}/stops`, param);
      return res;
    } catch (error) {
      return Promise.reject(error.response ? error.response : error);
    }
  };

  public async getListShapes(param): Promise<any> {
    try {
      const res = await customAxios.get(`${PATH_MASTER}/filter?master_id=${param.masterId}&route_id=${param.mainRouteId}&pattern_id=${param.specificRouteId}`);
      return res;
    } catch (error) {
      return Promise.reject(error.response ? error.response : error);
    }
  };

  public async updateRoute(masterId, shapes?): Promise<any> {
    try {
      var data = {
        master_id: masterId,
        shapes: shapes
      }
      const res = await customAxios.put(`${PATH_MASTER}`, data);
      return res;
    } catch (error) {
      return Promise.reject(error.response ? error.response : error);
    }
  };
}

